import React, { useEffect, useState } from "react";
import {
  CommonHeader,
  ConfirmationModal,
  EmptyListPage,
  ErrorSuccessModal,
  TableLoader,
} from "../../../../components/commons";
import { connect } from "react-redux";
import { EmptyList } from "../../../../assets/images";
import { RootState } from "../../../../redux/rootReducers";
import toast, { Toaster } from "react-hot-toast";
import { resetSession } from "../../../../redux/auth";
import {
  createRecruitmentModuleOpenPositionAction,
  deleteRecruitmentModuleOpenPositionAction,
  getRecruitmentModuleOpenPositionAction,
  resetHrmsError,
  resetHrmsMessage,
  resetHrmsStatusCode,
  resetHrmsSuccess,
  resetOpenPoisitionList,
  resetOpenPositionTotalCount,
  resetUniqueCheckFetching,
  updateRecruitmentModuleOpenPositionAction,
} from "../../../../redux/hrms";
import { SearchIcon } from "../../../../components/Icon";
import { useMenuCheck } from "../../../../customHooks/useMenuCheck";
import OpenPositionTable from "../../../../components/HRMS/OpenPosition/OpenPositionTable";
import AddEditOpenPosition from "../../../../components/HRMS/OpenPosition/AddEditOpenPosition";
import useDebounce from "../../../../customHooks/useDebounce";
import { SelectOptionType } from "../../../../redux/scheduling/schedulingTypes";
import { DepartmentListType } from "../../../../redux/clientSettings/clientSettingTypes";
import { GetUsersDepartmentPayloadType, UniqueClientGroupNamePayloadType } from "../../../../commonTypes/masterDataTypes";
import { checkUniqueClientGroupNameAction, getMasterDataUsersDepartmentAction, resetClientGroupUniqueCheckFetching, resetClientGroupUniqueCheckMessage } from "../../../../redux/masterData";
import { AddOpenPositionPayloadType, DeleteOpenPositionPayloadType, GetOpenPositionPayloadType, UpdateOpenPositionPayloadType } from "../../../../commonTypes/hrmsTypes";
import { OpenPoisitionListType } from "../../../../redux/hrms/hrmsTypes";
import { resetUniqueCheckMessage } from "../../../../redux/jobs";

type AppProps = {
  history: any;
  fetching: boolean;
  message: string;
  success: null | number;
  error: null | string;
  statusCode: null | number;
  openPoisitionList: OpenPoisitionListType[]|[];
  openPositionTotalCount: number;
  token: null | string;
  userDepartmentList: DepartmentListType[] | [];
  usersDepartmentFetching: boolean;
  totalDepartmentCount: number;
  uniqueCheckFetching:boolean;
  uniqueCheckMessage:string;
  dispatchResetHrmsStatusCode: () => void;
  dispatchResetSession: () => void;
  dispatchResetOpenPoisitionList: () => void;
  dispatchResetOpenPositionTotalCount: () => void;
  dispatchResetHrmsSuccess: () => void;
  dispatchResetHrmsMessage: () => void;
  dispatchResetHrmsError: () => void;
  dispatchGetRecruitmentModuleOpenPositionAction: (data: GetOpenPositionPayloadType) => void;
  dispatchUpdateRecruitmentModuleOpenPositionAction: (data: UpdateOpenPositionPayloadType) => void;
  dispatchAddRecruitmentModuleOpenPositionAction: (data: AddOpenPositionPayloadType) => void;
  dispatchGetMasterDataUsersDepartmentAction: (
    data: GetUsersDepartmentPayloadType
  ) => void;
  dispatchDeleteRecruitmentModuleOpenPositionAction:(data:DeleteOpenPositionPayloadType)=>void;
  dispatchResetUniquePositionCheckMessage: () => void;
  dispatchResetUniquePositionCheckFetching: () => void;
  dispatchCheckUniquePositionName: (data: UniqueClientGroupNamePayloadType) => void
};
const OpenPosition = ({
  history,
  fetching,
  message,
  success,
  error,
  token,
  statusCode,
  openPoisitionList,
  openPositionTotalCount,
  usersDepartmentFetching,
  totalDepartmentCount,
  dispatchResetSession,
  userDepartmentList,
  uniqueCheckFetching,
  uniqueCheckMessage,
  dispatchResetHrmsSuccess,
  dispatchResetHrmsError,
  dispatchResetHrmsMessage,
  dispatchResetOpenPoisitionList,
  dispatchResetOpenPositionTotalCount,
  dispatchResetHrmsStatusCode,
  dispatchGetRecruitmentModuleOpenPositionAction,
  dispatchUpdateRecruitmentModuleOpenPositionAction,
  dispatchAddRecruitmentModuleOpenPositionAction,
  dispatchGetMasterDataUsersDepartmentAction,
  dispatchDeleteRecruitmentModuleOpenPositionAction,
  dispatchResetUniquePositionCheckMessage,
  dispatchResetUniquePositionCheckFetching,
  dispatchCheckUniquePositionName,
}: AppProps) => {
  const [showAddEditOpenPositionModal, setShowAddEditOpenPositionModal] =
    useState<boolean>(false);
  
    const [finalUsersDepartmentList, setFinalUsersDepartmentList] = useState<any>(
      []
    );
    const [usersDepartmentOffset, setUsersDepartmentOffset] = useState<number>(0);
    const [usersDepartmentText, setUsersDepartmentText] = useState<string>("");
    const [departmentLimit, setDepartmentLimit] = useState(20);

    const [department, setDepartment] = useState<SelectOptionType>({
      label: "Select Department",
      value: null,
    });
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(20);
  const [data, setData] = useState<[] | OpenPoisitionListType[]>([]);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [searchValue, setSearchValue] = useState("");
  const [positionName, setPositionName] = useState<string>("");
  const [status, setStatus] = useState(true);
  const [id, setId] = useState<string | null | undefined>(null);
  const [positionNameError, setPositionNameError] = useState<string>("");
  const [refresh, setRefresh] = useState<boolean>(false);
  const [successMessage, setSuccessMessage] = useState<string>("");
  const [deleteId, setDeleteId] = useState("");
  const [showConfirmationModal, setShowConfirmationModal] =
    useState<boolean>(false);
  const [showDeleteConfirmationModal, setShowDeleteConfirmationModal] =
    useState<boolean>(false);

  //====================User Management=============================
  const [isAddOpenPositionPresent, setIsAddOpenPositionPresent] =
    useMenuCheck();
  const [isEditOpenPositionPresent, setIsEditOpenPositionPresent] =
    useMenuCheck();
  const [isSingleOpenPositionPresent, setIsSingleOpenPositionPresent] =
    useMenuCheck();
    const [isDeleteOpenPositionPresent, setIsDeleteOpenPositionPresent] =
    useMenuCheck();

  //=================================================================

  useEffect(() => {
    dispatchResetHrmsSuccess();
    dispatchResetHrmsError();
    dispatchResetHrmsMessage();
    dispatchResetOpenPoisitionList();
    dispatchResetOpenPositionTotalCount();
    dispatchResetHrmsStatusCode();
    setIsAddOpenPositionPresent("Add open job position", "menu");
    setIsEditOpenPositionPresent("Update open job position", "menu");
    setIsDeleteOpenPositionPresent("Delete open job position", "menu");
    setIsSingleOpenPositionPresent("List Open Job Positions", "menu")


  }, []);
  useEffect(() => {
    if (openPoisitionList?.length === 0) {
      setData(openPoisitionList);
    }
    if (offset > 0) {
      setData((prv: any) => [...prv, ...openPoisitionList]);
    } else {
      setData(openPoisitionList);
    }
  }, [openPoisitionList]);

  useEffect(() => {
    if (token) {
      let finalData: GetOpenPositionPayloadType = {
        token,
        limit,
        offset,
        search_term: searchValue,
      };
      if (openPositionTotalCount) {
        if (offset < openPositionTotalCount) {
          dispatchGetRecruitmentModuleOpenPositionAction(finalData);
        }
      } else {
        dispatchGetRecruitmentModuleOpenPositionAction(finalData);
      }
    }
  }, [offset]);

  const handleResetData = () => {
    setStatus(true);
    setPositionName("");
    setDepartment({
      label: "Select Department",
      value: null,
    })
    setOffset(0);
  };
  const toggleAddEditOpenPositionModal = () => {
    if (!showAddEditOpenPositionModal) {
      handleResetData();
      if (token) {
        if (usersDepartmentOffset <= +totalDepartmentCount) {
          const finalData = {
            token,
            status: 1,
            offset: usersDepartmentOffset,
            limit: departmentLimit,
            searchValue: usersDepartmentText,
          };
          dispatchGetMasterDataUsersDepartmentAction(finalData);
        }
      }
    }

    setShowAddEditOpenPositionModal(!showAddEditOpenPositionModal);
  };

  const handleEditOpenPositionCategory = (data: any) => {
    setIsEdit(true);
    setShowAddEditOpenPositionModal(true);
    setPositionName(data?.position_name);
    setStatus(data?.status);
    setDepartment({
      label: data?.department?.department_name,
      value:  data?.department?.department_id
    })
    setId(data?._id);
  };

  useEffect(() => {
    if (!showAddEditOpenPositionModal) {
      setIsEdit(false);
    }
  }, [showAddEditOpenPositionModal]);

  useDebounce(
    () => {
      if (searchValue) {
        fetchNewData();
      } else {
        setOffset(0)
      }
    },
    500,
    [searchValue]
  );

  const fetchNewData = () => {
    dispatchResetOpenPoisitionList();
    if (token) {
      let finalData = {
        token,
        search_term: searchValue,
        limit,
        offset,
      };
      if (offset === 0) {
        dispatchGetRecruitmentModuleOpenPositionAction(finalData);
      } else {
        setOffset(0);
      }
    }
  };

  // department
  useEffect(() => {
    const finalDepartmentListData = userDepartmentList?.map((data: any) => {
      return {
        value: data?._id,
        label: `${data?.department_name}`,
      };
    });

    if (
      (usersDepartmentOffset > 0) &&
      finalUsersDepartmentList?.length &&
      finalDepartmentListData?.length
    ) {
      setFinalUsersDepartmentList([
        ...finalUsersDepartmentList,
        ...finalDepartmentListData,
      ]);
    } else if (finalDepartmentListData?.length) {
      setFinalUsersDepartmentList([...finalDepartmentListData]);
    } else {
      setFinalUsersDepartmentList([]);
    }
  }, [userDepartmentList]);

  useEffect(() => {
    if (token) {
      if (usersDepartmentOffset <= +totalDepartmentCount) {
        const finalData = {
          token,
          status: 1,
          offset: usersDepartmentOffset,
          limit: departmentLimit,
          searchValue: usersDepartmentText,
        };
        dispatchGetMasterDataUsersDepartmentAction(finalData);
      }
    }
  }, [usersDepartmentOffset]);


  useDebounce(
    () => {
      if (usersDepartmentText) {
        fetchUsersDepartmentNewData("userDepartment");
      } else {
        const finalData = {
          token,
          status: 1,
          offset: usersDepartmentOffset,
          limit: limit,
          searchValue: usersDepartmentText,
        };
        dispatchGetMasterDataUsersDepartmentAction(finalData);
      }
    },
    500,
    [usersDepartmentText]
  );
  const fetchUsersDepartmentNewData = (type: string) => {
    const finalData = {
      token,
      status: 1,
      offset:
         usersDepartmentOffset,
      limit: limit,
      searchValue:
         usersDepartmentText,
    };
    dispatchGetMasterDataUsersDepartmentAction(finalData);
  };

  const handleDepartmentChange = (department: SelectOptionType) => {
    setDepartment(department);
  };
 
  useDebounce(
    () => {
        if (positionName?.trim() && token) {
            const finalData = {
                token,
                operation: isEdit ? "update" : "add",
                uniqueCheck: "open_job_position_name",
                name: positionName?positionName.trim():"",
                dataId: isEdit ? id : ""
            }
            dispatchCheckUniquePositionName(finalData);
        }
    },
    500,
    [positionName]
)

  const handleSuccessMessage = (type: string) => {
    switch (type) {
      case "created-open-position":
        return setSuccessMessage("Job position has been added successfully!");
      case "updated-open-position":
        return setSuccessMessage("Job position has updated Successfully!");
      default:
        return setSuccessMessage("");
    }
  };
  const handleToogleStatusChange = () => {
      setStatus(!status);
  };
  const handlePositionNameChange = (e: any) => {
    setPositionName(e.target.value);
  };
  const handleSearch = (e: any) => {
    let value = e.target.value;
    setSearchValue(value);

    if (value?.length === 0) {
      let finalData = {
        offset: 0,
        limit,
        token,
      };
      dispatchGetRecruitmentModuleOpenPositionAction(finalData);
    }
  };
  const handleAddOpenPosition = () => {
    setRefresh(!refresh);
    dispatchResetOpenPoisitionList();
    dispatchResetHrmsStatusCode();
    dispatchResetUniquePositionCheckFetching();
    dispatchResetUniquePositionCheckMessage();
    if (positionName?.trim()?.length > 0) {
      if (isEdit) {
        let updateData = {
          token: token,
          position_name: positionName,
          status: status==true?1:0,
          position_id: id,
          department_id:   department?.label === "Select..." ||
          department?.label === "All Departments"
            ? null
            : department?.value,
        };
        dispatchUpdateRecruitmentModuleOpenPositionAction(updateData);
        handleSuccessMessage("updated-open-position");
      } else {
        let finalAddData = {
          token,
          position_name: positionName,
          department_id:   department?.label === "Select..." ||
          department?.label === "All Departments"
            ? null
            : department?.value,
          status:status==true?1:0
        };
        dispatchAddRecruitmentModuleOpenPositionAction(finalAddData);
        handleSuccessMessage("created-open-position");
        setSearchValue("");
      }
    }

    let finalData = {
      token,
      limit,
      offset,
      search_term: searchValue,
    };
    if (offset === 0) {
      dispatchGetRecruitmentModuleOpenPositionAction(finalData);
    } else {
      setOffset(0);
    }
  };
  const onScroll = () => {
    if (!fetching) {
      const scrollTop = document.documentElement.scrollTop;
      const scrollHeight = document.documentElement.scrollHeight;
      const clientHeight = document.documentElement.clientHeight;

      if (
        offset < openPositionTotalCount &&
        !fetching &&
        Math.ceil((75 / 100) * scrollHeight) <= scrollTop + clientHeight
      ) {
        if (openPoisitionList?.length > 0) {
          if (!fetching && offset < openPositionTotalCount) {
            setOffset(offset + limit);
          }
        }
      }
    }
  };
  useEffect(() => {
    if (offset === 0) {
      window.scrollTo(0, 0);
    } else {
      window.scrollTo(0, 0);
      setOffset(0);
    }
  }, [success]);
  useEffect(() => {
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [openPoisitionList]);

  const handleDelete = (id: string) => {
    setDeleteId(id);
    setShowDeleteConfirmationModal(true);
  };
  const handleDeleteConfirmationModal = () => {
    setShowDeleteConfirmationModal(!showDeleteConfirmationModal);
  };
  const DeleteOpenPosition = (deleteId: string) => {
    if (token && deleteId) {
      const finalData = {
        token,
        id: deleteId,
      };
      dispatchDeleteRecruitmentModuleOpenPositionAction(finalData);
    }
  };
 
  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } 
     
      else if (!!error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetHrmsError();
            }}
          />
        );
      }
    }
    if (success === 1 && message?.includes("added successfully!")) {
      dispatchResetOpenPoisitionList();
      dispatchResetHrmsSuccess();
      dispatchResetHrmsMessage();
      toast.success(successMessage, {
        duration: 2000,
      });
      if (token) {
        let finalData = {
          token,
          limit,
          offset: 0,
          search_term: searchValue,

        };
        if (offset === 0) {
          dispatchGetRecruitmentModuleOpenPositionAction(finalData);
        } else {
          setOffset(0);
        }
      }
    }
    if (success === 1 && message?.includes("updated successfully!")) {
      dispatchResetOpenPoisitionList();
      dispatchResetHrmsSuccess();
      dispatchResetHrmsMessage();
      toast.success(successMessage, {
        duration: 2000,
      });
  
      if (token) {
        let finalData = {
          token,
          limit,
          offset: 0,
          search_term: searchValue,

        };
        if (offset === 0) {
          dispatchGetRecruitmentModuleOpenPositionAction(finalData);
        }
      }
    }
    if (success === 1 && message?.includes("deleted successfully!")) {
      dispatchResetOpenPoisitionList();
      dispatchResetHrmsSuccess();
      dispatchResetHrmsMessage();
      toast.success("Open job position has been deleted successfully!!", {
        duration: 2000,
      });
      let finalData = {
        token,
        limit,
        offset,
        searchValue,
      };
      if (offset === 0) {
        dispatchGetRecruitmentModuleOpenPositionAction(finalData);
      }
    }

    return false;
  };

  return (
    <div className="row">
      <div className="col-md-6">
        <CommonHeader title="Open Positions" />
      </div>
      <div className="col-md-12">
        {isSingleOpenPositionPresent && 
        <div className="jobs-card">
          <div className="header">
            <div className="left-header">
              <div className="heading">Open Positions List</div>
              {!fetching && (
                <div
                  className="sub-heading"
                  style={{ marginTop: "-22px" }}
                >{`Total ${
                  openPositionTotalCount ? openPositionTotalCount : 0
                } position found`}</div>
              )}
            </div>
            <div className="right-header">
              <div
                className={`${
                  !!openPoisitionList?.length ? "col-md-6" : "col-md-10"
                } position-relative`}
              >
                <span
                  style={{ position: "absolute", top: "8px", left: "25px" }}
                >
                  <SearchIcon />
                </span>
                <input
                  className="form-control"
                  type="text"
                  placeholder="Search"
                  onChange={(e) => handleSearch(e)}
                  style={{ paddingLeft: "35px" }}
                  value={searchValue}
                />
              </div>
              {isAddOpenPositionPresent && !!openPoisitionList?.length && (
                <button
                  className="btn btn-primary"
                  onClick={toggleAddEditOpenPositionModal}
                >
                  + Add Open Position
                </button>
              )}
            </div>
          </div>
          <div>
            {fetching && offset == 0 ? (
              <TableLoader Rows={10} ColumnPerRow={7} />
            ) : openPoisitionList?.length > 0 ? (
              <OpenPositionTable
                data={data}
                handleEditOpenPositionCategory={handleEditOpenPositionCategory}
                fetching={fetching}
                offset={offset}
                isEditOpenPositionPresent={isEditOpenPositionPresent}
                isDeleteOpenPositionPresent={isDeleteOpenPositionPresent}
                handleDelete={handleDelete}
              />
            ) : (
              <div className="mt-5 pb-5">
                {!fetching && data?.length === 0 && (
                  <EmptyListPage
                    title="No Open Position List Found!"
                    image={EmptyList}
                    imageWidth="30%"
                    showAddButton
                    buttonTitle="+ Open Position"
                    onButtonClick={toggleAddEditOpenPositionModal}
                  />
                )}
              </div>
            )}
          </div>
        </div>
        }
      </div>
      {showAddEditOpenPositionModal && (
        <AddEditOpenPosition
          showAddEditOpenPositionModal={showAddEditOpenPositionModal}
          toggleAddEditOpenPositionModal={toggleAddEditOpenPositionModal}
          isEdit={isEdit}
          positionName={positionName}
          positionNameError={positionNameError}
          handleAddOpenPosition={handleAddOpenPosition}
          handlePositionNameChange={handlePositionNameChange}
          handleToogleStatusChange={handleToogleStatusChange}
          status={status}
          finalUsersDepartmentList={finalUsersDepartmentList}
          department={department}
          handleDepartmentChange={handleDepartmentChange}
          usersDepartmentFetching={usersDepartmentFetching}
          setUsersDepartmentOffset={setUsersDepartmentOffset}
          setUsersDepartmentText={setUsersDepartmentText}
          departmentLimit={departmentLimit}
          uniqueCheckFetching={uniqueCheckFetching}
          uniqueCheckMessage={uniqueCheckMessage}
        />
      )}
        {showDeleteConfirmationModal && (
        <ConfirmationModal
          toggle={() => {
            handleDeleteConfirmationModal();
          }}
          isOpen={showDeleteConfirmationModal}
          title={`Delete Open Position?`}
          message={`Are you sure you want to Delete?`}
          confirmButtonText="Delete"
          onPressConfirm={() => {
            DeleteOpenPosition(deleteId);
            handleDeleteConfirmationModal();
          }}
        />
      )}
      {handleErrorModal()}
      <Toaster />
    </div>
  );
};
const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  fetching: state.hrms.fetching,
  statusCode: state.hrms.statusCode,
  error: state.hrms.error,
  openPoisitionList: state.hrms.openPoisitionList,
  openPositionTotalCount: state.hrms.openPositionTotalCount,
  success: state.hrms.success,
  message: state.hrms.message,
  userDepartmentList: state.masterData.userDepartmentList,
  totalDepartmentCount: state.masterData.userDepartmentTotalCount,
  usersDepartmentFetching: state.masterData.fetching,
  uniqueCheckMessage: state.masterData.clientGroupUniqueCheckMessage,
  uniqueCheckFetching: state.masterData.clientGroupUniqueCheckFetching,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetHrmsSuccess: () => dispatch(resetHrmsSuccess()),
  dispatchResetHrmsError: () => dispatch(resetHrmsError()),
  dispatchResetHrmsMessage: () => dispatch(resetHrmsMessage()),
  dispatchResetOpenPoisitionList: () => dispatch(resetOpenPoisitionList()),
  dispatchResetOpenPositionTotalCount: () =>
    dispatch(resetOpenPositionTotalCount()),
  dispatchResetHrmsStatusCode: () => dispatch(resetHrmsStatusCode()),
  dispatchGetRecruitmentModuleOpenPositionAction: (data: GetOpenPositionPayloadType) =>
    dispatch(getRecruitmentModuleOpenPositionAction(data)),
  dispatchUpdateRecruitmentModuleOpenPositionAction: (data: UpdateOpenPositionPayloadType) =>
    dispatch(updateRecruitmentModuleOpenPositionAction(data)),
  dispatchAddRecruitmentModuleOpenPositionAction: (data: AddOpenPositionPayloadType) =>
    dispatch(createRecruitmentModuleOpenPositionAction(data)),
  dispatchGetMasterDataUsersDepartmentAction: (
    data: GetUsersDepartmentPayloadType
  ) => dispatch(getMasterDataUsersDepartmentAction(data)),
  dispatchDeleteRecruitmentModuleOpenPositionAction: (
    data: DeleteOpenPositionPayloadType
  ) => dispatch(deleteRecruitmentModuleOpenPositionAction(data)),
  dispatchCheckUniquePositionName: (data: UniqueClientGroupNamePayloadType) => dispatch(checkUniqueClientGroupNameAction(data)),
  dispatchResetUniquePositionCheckMessage: () => dispatch(resetClientGroupUniqueCheckMessage()),
  dispatchResetUniquePositionCheckFetching: () => dispatch(resetClientGroupUniqueCheckFetching())

});
export default connect(mapStateToProps, mapDispatchToProps)(OpenPosition);
